import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { ODCSharingInfo, ODBSharingInfo } from 'owa-sharing-data';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { AttachmentFileType, CloudFile } from 'owa-attachment-file-types';

export function createCloudFileFromSharingLink(
    sharingLink: SharingLinkInfo,
    providerId: string
): CloudFile {
    let location: string = null;
    let fileId: string = null;
    switch (sharingLink.providerType) {
        case AttachmentDataProviderType.OneDriveConsumer:
            const oDCsharingInfo: ODCSharingInfo = <ODCSharingInfo>sharingLink.sharingInfo;
            location = oDCsharingInfo.location;
            fileId = oDCsharingInfo.providerFileId;
            break;
        case AttachmentDataProviderType.OneDrivePro:
            const oDBsharingInfo: ODBSharingInfo = <ODBSharingInfo>sharingLink.sharingInfo;
            location = oDBsharingInfo.canonicalUrl;
            break;
        default:
            break;
    }

    return {
        fileType: AttachmentFileType.Cloud,
        name: sharingLink.fileName,
        size: null,
        providerId: providerId,
        providerType: sharingLink.providerType,
        location: location,
        providerEndpointUrl: null,
        isFolder: false,
        fileId: fileId,
        fileParentId: null,
        thumbnailUrl: null,
        previewUrl: null,
        type: sharingLink.mimeType,
    };
}
